import React from "react";

import { faLanguage } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import toast from "~/ui/toast";

const TRANSLATION_WARNING_TOAST_ID = "automatic-translation-detected";

/**
 * Warn the user that browser page-translation is active and can break Fellow.
 *
 * Stays up for at least 20s, and can be dismissed early by clicking the toast or
 * its close button. Uses a fixed toast id so it can only ever appear once at a
 * time.
 */
export function showTranslationWarningToast(): void {
	toast.warn(
		<>
			Some translation software is known to cause issues with Fellow. If you run into any errors, please disable it,
			reload the page, and try again.
		</>,
		{
			toastId: TRANSLATION_WARNING_TOAST_ID,
			title: (
				<span>
					<FontAwesomeIcon icon={faLanguage} /> Automatic translation software detected
				</span>
			),
			autoClose: 20000,
			closeButton: true,
			closeOnClick: true,
		},
	);
}
